var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_4564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6189 9C37.8944 9 46.2371 17.3429 46.2371 27.6189C46.2371 37.8953 37.8944 46.2382 27.6189 46.2382C17.3428 46.2382 9 37.8953 9 27.6189C9 17.3429 17.3428 9 27.6189 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6189 9C37.8944 9 46.2371 17.3429 46.2371 27.6189C46.2371 37.895 37.8944 46.2379 27.6189 46.2379C17.3428 46.2379 9 37.895 9 27.6189C9 17.3429 17.3428 9 27.6189 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2314 27.6189L25.6542 31.0419C25.8925 31.2799 25.8925 31.6669 25.6542 31.905C25.4161 32.1433 25.0292 32.1433 24.7911 31.905L20.9367 28.0506C20.6982 27.8123 20.6982 27.4258 20.9367 27.1875L24.7911 23.3331C25.0292 23.0948 25.4161 23.0948 25.6542 23.3331C25.8925 23.5711 25.8925 23.9582 25.6542 24.1962L22.2314 27.6189ZM33.8684 27.0088H26.0289C25.692 27.0088 25.4186 27.2823 25.4186 27.6192C25.4186 27.9558 25.692 28.2295 26.0289 28.2295H33.8684C34.2053 28.2295 34.4788 27.9558 34.4788 27.6192C34.4788 27.2823 34.2053 27.0088 33.8684 27.0088Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_4564",
    x: 0.6,
    y: 0.6,
    width: 54.0371,
    height: 54.0382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_4564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_4564",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.a6b21808b40cd0d7763a742cb9a45068.svg";
export { ForwardRef as ReactComponent };